var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedIn = function SvgLinkedIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.596 25H.413V8.642h5.183V25ZM3.002 6.41C1.344 6.411 0 5.066 0 3.441c0-.78.316-1.528.88-2.08A3.033 3.033 0 0 1 3.001.5c.796 0 1.56.31 2.122.862.563.551.88 1.3.88 2.08 0 1.624-1.346 2.97-3.002 2.97ZM24.994 25h-5.171v-7.963c0-1.898-.04-4.331-2.695-4.331-2.695 0-3.108 2.061-3.108 4.194V25H8.843V8.642h4.97v2.232h.073c.692-1.285 2.382-2.642 4.904-2.642 5.246 0 6.21 3.385 6.21 7.782V25h-.006Z"
  })));
};
export default SvgLinkedIn;